module.exports = __webpack_public_path__ + "static/media/de_ancient.5e248aac.svg";